/** Days between due date (start of day) and today (start of day), when overdue. */
export function computeDaysOverdueFromDueDate(dueDate: string): number | undefined {
  if (!dueDate) return undefined;
  const due = new Date(dueDate);
  if (Number.isNaN(due.getTime())) return undefined;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);

  const days = Math.floor((today.getTime() - due.getTime()) / 86_400_000);
  return days > 0 ? days : undefined;
}

export function resolveRepaymentDaysOverdue(
  repayment: { dueDate?: string; daysOverdue?: number },
  maxDaysOverdue?: number,
): number | undefined {
  if (repayment.daysOverdue != null && repayment.daysOverdue > 0) {
    return repayment.daysOverdue;
  }

  const fromDueDate = repayment.dueDate
    ? computeDaysOverdueFromDueDate(repayment.dueDate)
    : undefined;
  if (fromDueDate != null) return fromDueDate;

  if (maxDaysOverdue != null && maxDaysOverdue > 0) return maxDaysOverdue;

  return undefined;
}
